export default {
  navigationBarTitleText: '户型详情'
};
